"use client";

import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import { Button } from "@/components/ds/button";
import { PageHeader, WorkspacePage } from "@/components/ds/workspace-page";
import { downloadBackup } from "@/lib/api/endpoints/data-management";

export function BackupDownloadPage() {
  const { backupId } = useParams<{ backupId: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") ?? "";
  const [status, setStatus] = useState<"downloading" | "done" | "error">("downloading");

  useEffect(() => {
    if (!backupId || !token) {
      setStatus("error");
      return;
    }
    void downloadBackup(backupId, token)
      .then(() => setStatus("done"))
      .catch(() => setStatus("error"));
  }, [backupId, token]);

  return (
    <WorkspacePage>
      <PageHeader
        title="Backup download"
        description={
          status === "downloading"
            ? "Preparing your download."
            : status === "done"
              ? "The backup download has started."
              : "The backup link is invalid, expired, or no longer available."
        }
      />
      <div className="mt-ds-4 max-w-xl rounded-card border border-card-border bg-surface-primary p-ds-5 shadow-raised">
        <p className="text-caption text-muted">
          {status === "downloading"
            ? "Keep this page open for a moment."
            : status === "done"
              ? "For standard backups, the server file is removed after this download."
              : "Check your latest backup notification or request a new backup."}
        </p>
        <div className="mt-ds-4">
          <Button type="button" variant="secondary" onClick={() => navigate("/devices")}>
            Back to data loggers
          </Button>
        </div>
      </div>
    </WorkspacePage>
  );
}
